// API units

export const apiBaseURL = process.env.REACT_APP_API_URL;
export const apiBaseImageUpload = process.env.REACT_APP_API_IMGUPLOAD;
export const serviceId = process.env.REACT_APP_SERVICE_ID;
export const templateId = process.env.REACT_APP_TEMPLATE_ID;
export const publicKey = process.env.REACT_APP_PUBLIC_KEY;
